import { unsafeCSS as f, LitElement as v, html as d, nothing as s } from "lit";
import { property as i } from "lit/decorators.js";
import { validPropertyValues as a, defineCustomElement as k } from "@justeattakeaway/pie-webc-core";
const g = `*,*:after,*:before{box-sizing:inherit}.c-link{--link-font-family: var(--dt-font-interactive-l-family);--link-font-size: calc(var(--dt-font-size-16) * 1px);--link-line-height: calc(var(--dt-font-size-16-line-height) * 1px);--link-font-weight: var(--dt-font-weight-regular);--link-text-color: var(--dt-color-content-link);--link-text-decoration: var(--dt-font-style-underline);--link-icon-size: 16px;--link-icon-offset-top: var(--dt-spacing-a);display:inline-block;font-family:var(--link-font-family);font-size:var(--link-font-size);line-height:var(--link-line-height);font-weight:var(--link-font-weight);color:var(--link-text-color);text-decoration:var(--link-text-decoration);cursor:pointer}.c-link:hover,.c-link:active{--link-text-decoration: none}.c-link[tag=button]{outline:none;border:none;-webkit-user-select:none;user-select:none;background:transparent;padding:0}.c-link[variant=high-visibility]{--link-text-color: var(--dt-color-content-link-distinct)}.c-link[variant=inverse]{--link-text-color: var(--dt-color-content-link-inverse)}.c-link[size=small]{--link-font-size: calc(var(--dt-font-size-14) * 1px);--link-line-height: calc(var(--dt-font-size-14-line-height) * 1px);--link-icon-offset-top: 2px}.c-link[underline=reversed][isStandalone]{--link-text-decoration: none}.c-link[underline=reversed][isStandalone]:hover,.c-link[underline=reversed][isStandalone]:active{--link-text-decoration: var(--dt-font-style-underline)}.c-link[isBold]{--link-font-weight: var(--dt-font-weight-bold)}.c-link[isStandalone]{display:block;width:fit-content}.c-link[hasVisited]:visited{color:var(--dt-color-content-link-visited)}.c-link[hasVisited]:visited[variant=inverse]{color:var(--dt-color-content-link-visited-inverse)}.c-link:focus-visible{outline:none;border-radius:2px;box-shadow:0 0 0 2px var(--dt-color-focus-inner),0 0 0 4px var(--dt-color-focus-outer)}.c-link-content{display:flex;gap:var(--dt-spacing-a)}::slotted(.c-pieIcon),::slotted(svg){display:inline-flex;margin-block-start:var(--link-icon-offset-top);height:var(--link-icon-size);width:var(--link-icon-size)}
`, y = ["default", "high-visibility", "inverse"], m = ["small", "medium"], b = ["leading", "trailing"], x = ["a", "button"], $ = ["submit", "button", "reset", "menu"], S = ["default", "reversed"];
var z = Object.defineProperty, B = Object.getOwnPropertyDescriptor, n = (p, e, r, c) => {
  for (var o = c > 1 ? void 0 : c ? B(e, r) : e, h = p.length - 1, u; h >= 0; h--)
    (u = p[h]) && (o = (c ? u(e, r, o) : u(o)) || o);
  return c && o && z(e, r, o), o;
};
const l = "pie-link";
class t extends v {
  constructor() {
    super(...arguments), this.tag = "a", this.variant = "default", this.size = "medium", this.underline = "default", this.iconPlacement = "leading", this.isBold = !1, this.isStandalone = !1, this.hasVisited = !1, this.type = "submit";
  }
  /**
   * Renders the link content.
   * Icons are only shown in block elements
   * @private
   */
  renderContent() {
    const { iconPlacement: e, isStandalone: r } = this;
    return d`
                <span class="c-link-content">
                    ${r && e === "leading" ? d`<slot name="icon"></slot>` : s}
                    <slot></slot>
                    ${r && e === "trailing" ? d`<slot name="icon"></slot>` : s}
                </span>`;
  }
  /**
   * Renders the link as a button element.
   *
   * @private
   */
  renderButton() {
    var e;
    return d`
            <button
                data-test-id="pie-link"
                class="c-link"
                tag=${this.tag || "button"}
                variant=${this.variant || "default"}
                size=${this.size || "medium"}
                underline=${this.underline || "default"}
                ?isBold=${this.isBold}
                ?isStandalone=${this.isStandalone}
                ?hasVisited=${this.hasVisited}
                type=${this.type || "submit"}
                aria-label=${((e = this.aria) == null ? void 0 : e.label) || s}>
                    ${this.renderContent()}
            </button>`;
  }
  /**
   * Renders the link as an anchor element.
   *
   * @private
   */
  renderAnchor() {
    var e;
    return d`
            <a
                data-test-id="pie-link"
                class="c-link"
                tag=${this.tag || "a"}
                variant=${this.variant || "default"}
                size=${this.size || "medium"}
                underline=${this.underline || "default"}
                ?isBold=${this.isBold}
                ?isStandalone=${this.isStandalone}
                ?hasVisited=${this.hasVisited}
                href=${this.href || ""}
                target=${this.target || s}
                rel=${this.rel || s}
                aria-label=${((e = this.aria) == null ? void 0 : e.label) || s}>
                    ${this.renderContent()}
            </a>`;
  }
  render() {
    return this.tag === "button" ? this.renderButton() : this.renderAnchor();
  }
}
t.styles = f(g);
n([
  i(),
  a(l, x, "a")
], t.prototype, "tag", 2);
n([
  i({ type: String }),
  a(l, y, "default")
], t.prototype, "variant", 2);
n([
  i({ type: String }),
  a(l, m, "medium")
], t.prototype, "size", 2);
n([
  i({ type: String }),
  a(l, S, "default")
], t.prototype, "underline", 2);
n([
  i({ type: String }),
  a(l, b, "leading")
], t.prototype, "iconPlacement", 2);
n([
  i({ type: String, reflect: !0 })
], t.prototype, "href", 2);
n([
  i({ type: String, reflect: !0 })
], t.prototype, "target", 2);
n([
  i({ type: String, reflect: !0 })
], t.prototype, "rel", 2);
n([
  i({ type: Boolean })
], t.prototype, "isBold", 2);
n([
  i({ type: Boolean })
], t.prototype, "isStandalone", 2);
n([
  i({ type: Boolean })
], t.prototype, "hasVisited", 2);
n([
  i(),
  a(l, $, "submit")
], t.prototype, "type", 2);
n([
  i({ type: Object })
], t.prototype, "aria", 2);
k(l, t);
export {
  t as PieLink,
  $ as buttonTypes,
  b as iconPlacements,
  m as sizes,
  x as tags,
  S as underlineTypes,
  y as variants
};
